export const moduleKeys = {
    modules: (subdomain, id) => ['modules', subdomain, id],
};
